import api from '../../../api';

/**
 * Fetch monthly achievement form data.
 * @param {number} salesId
 * @param {number} year
 * @param {number} month  1–12
 */
export const fetchMonthlyAchievementForm = async (salesId, year, month) => {
    const res = await api.get('/crm/achievement-form/monthly', {
        params: { salesId, year, month },
    });
    return res.data;
};

/**
 * Fetch quarterly achievement form data.
 * @param {number} salesId
 * @param {number} year
 * @param {number} quarter  1–4
 */
export const fetchQuarterlyAchievementForm = async (salesId, year, quarter) => {
    const res = await api.get('/crm/achievement-form/quarterly', {
        params: { salesId, year, quarter },
    });
    return res.data;
};

/**
 * Update CMF and Operation Expenditures for one invoice row.
 * @param {number} invoiceId
 * @param {number|null} cmf
 * @param {number|null} operationExpenditures
 */
export const updateInvoiceFinancials = async (invoiceId, cmf, operationExpenditures) => {
    const res = await api.patch(`/crm/achievement-form/invoice/${invoiceId}/financials`, {
        cmf: cmf ?? null,
        operationExpenditures: operationExpenditures ?? null,
    });
    return res.data;
};

/**
 * Fetch active users assigned to at least one lead (for sales dropdown).
 */
export const fetchSalesOptions = async () => {
    const res = await api.get('/crm/achievement-form/sales-options');
    const data = Array.isArray(res.data) ? res.data : res.data?.data || [];
    return data.map(u => ({ id: u.id, name: u.name || 'Unknown' }));
};
